<template>
  <div>
    <a-collapse
      :bordered="true"
      expand-icon-position="right"
      :activeKey="['1', '2', '3', '4']"
      class="detail-collapse"
    >
      <!-- ===================== 权证基本信息 ===================== -->
      <a-collapse-panel key="1">
        <template v-slot:header>
          <a-space align="center">
            <div class="title_icon"></div>
            <div
              class="ant-descriptions-title"
              style="font-size: 16px; margin-bottom: 0px"
            >
              权证基本信息
            </div>
          </a-space>
        </template>
        <a-form-model class="basic" :model="form" :rules="rules" ref="baseForm">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item label="系统编码" prop="systemNo">
                <a-input v-model="form.systemNo" disabled />
              </a-form-model-item>
            </a-col>

            <a-col :span="12">
              <a-form-model-item label="权证编号" prop="certificateNo">
                <a-input v-model="form.certificateNo" />
              </a-form-model-item>
            </a-col>

            <a-col :span="24">
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-model-item label="权证类型" prop="type">
                    <a-select v-model="form.type" placeholder="请选择">
                      <a-select-option value="1">产权</a-select-option>
                      <a-select-option value="2">使用权</a-select-option>
                      <a-select-option value="3">其他</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>

                <a-col :span="12">
                  <a-form-model-item
                    v-if="form.type == 3"
                    label="标签"
                    prop="type"
                  >
                    <a-select v-model="form.label" placeholder="请选择">
                      <a-select-option value="产权">在建工程</a-select-option>
                      <a-select-option value="租赁权">其他</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>

                <a-col :span="12">
                  <a-form-model-item
                    v-if="form.type == 2"
                    label="使用权证明文件名"
                    prop="area"
                  >
                    <a-input v-model="form.area" style="width: 100%" />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>

            <a-col :span="24">
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-model-item
                    label="权证面积（㎡）"
                    prop="area"
                    extra="提示：请填写建筑面积、套数、填写实际面积。"
                  >
                    <a-input-number v-model="form.area" style="width: 100%" />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>

            <!-- 字典 -->
            <a-col :span="12">
              <a-form-model-item label="权证地址" prop="address">
                <a-input v-model="form.address" />
              </a-form-model-item>
            </a-col>

            <a-col :span="12">
              <a-form-model-item label="权证地址详细地点" prop="address">
                <a-input v-model="form.address" />
              </a-form-model-item>
            </a-col>

            <a-col :span="24" style="margin-bottom: -10px">
              <a-form-model-item label="实际地址类型" prop="sameAddress">
                <a-radio-group v-model="form.sameAddress">
                  <a-radio :value="true">与产证地址一致</a-radio>
                  <a-radio :value="false">与产证地址不一致</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>

            <a-col :span="12">
              <a-form-model-item label="实际地址" prop="realAddress">
                <a-input
                  v-model="form.realAddress"
                  :disabled="form.sameAddress"
                />
              </a-form-model-item>
            </a-col>

            <a-col :span="12">
              <a-form-model-item
                label="实际地址详细地址"
                prop="realAddressDetail"
              >
                <a-input
                  v-model="form.realAddressDetail"
                  :disabled="form.sameAddress"
                />
              </a-form-model-item>
            </a-col>

            <template v-if="form.realAddress == 1">
              <a-col :span="12">
                <a-form-model-item label="所属地段" prop="type">
                  <a-select v-model="form.type" placeholder="请选择">
                    <a-select-option value="1">产权</a-select-option>
                    <a-select-option value="2">使用权</a-select-option>
                    <a-select-option value="3">其他</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>

              <a-col :span="12">
                <a-form-model-item label="是否涉及以下板块" prop="sameAddress">
                  <a-radio-group v-model="form.sameAddress">
                    <a-radio :value="true">是</a-radio>
                    <a-radio :value="false">否</a-radio>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item label="所属板块" prop="sameAddress">
                  <a-checkbox-group v-model="form.board" style="width: 100%">
                    <a-row :gutter="[0, 12]">
                      <a-col :span="6" v-for="item in boardList" :key="item">
                        <a-checkbox :value="item">{{ item }}</a-checkbox>
                      </a-col>
                    </a-row>
                  </a-checkbox-group>
                </a-form-model-item>
              </a-col>
            </template>

            <a-col :span="24">
              <a-form-model-item
                label="权证用途"
                prop="usage"
                extra="提示：请填写房屋用途，若无，填写“/”。"
              >
                <a-input v-model="form.usage" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-collapse-panel>

      <!-- ===================== 权利人信息 ===================== -->
      <a-collapse-panel key="2">
        <template v-slot:header>
          <a-space align="center">
            <div class="title_icon"></div>
            <div
              class="ant-descriptions-title"
              style="font-size: 16px; margin-bottom: 0px"
            >
              权利人信息
            </div>
          </a-space>
        </template>
        <a-form-model :model="form" layout="vertical">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item label="是否授权登记" prop="sameAddress">
                <a-radio-group v-model="form.sameAddress">
                  <a-radio :value="true">是</a-radio>
                  <a-radio :value="false">否</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>

            <a-col :span="12">
              <a-form-model-item label="权利人类型">
                <a-input v-model="form.rightName" />
              </a-form-model-item>
            </a-col>

            <a-col :span="12">
              <a-form-model-item label="权利人名称">
                <a-input v-model="form.rightName" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-collapse-panel>

      <!-- ===================== 申请人信息 ===================== -->
      <a-collapse-panel key="3">
        <template v-slot:header>
          <a-space align="center">
            <div class="title_icon"></div>
            <div
              class="ant-descriptions-title"
              style="font-size: 16px; margin-bottom: 0px"
            >
              申请人信息
            </div>
          </a-space>
        </template>
        <a-form-model class="obligee" :model="form" layout="vertical">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item label="申请人名称">
                <a-input v-model="form.applicantName" />
              </a-form-model-item>
            </a-col>

            <a-col :span="12">
              <a-form-model-item label="手机号">
                <a-input v-model="form.applicantPhone" />
              </a-form-model-item>
            </a-col>

            <a-col :span="12">
              <a-form-model-item label="申请企业名称">
                <a-input v-model="form.applicantCompany" />
              </a-form-model-item>
            </a-col>

            <a-col :span="12">
              <a-form-model-item label="统一社会信用代码">
                <a-input v-model="form.applicantCode" />
              </a-form-model-item>
            </a-col>

            <a-col :span="12">
              <a-form-model-item label="申请人类型">
                <a-select v-model="form.applicantType">
                  <a-select-option value="企业">企业</a-select-option>
                  <a-select-option value="国资公司">国资公司</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-collapse-panel>

      <!-- ===================== 上传附件 ===================== -->
      <a-collapse-panel key="4">
        <template v-slot:header>
          <a-space align="center">
            <div class="title_icon"></div>
            <div
              class="ant-descriptions-title"
              style="font-size: 16px; margin-bottom: 0px"
            >
              上传附件
            </div>
          </a-space>
        </template>
        <a-table
          :columns="fileColumns"
          :data-source="form.fileList"
          :pagination="false"
          rowKey="id"
        >
          <template slot="file" slot-scope="text, record">
            <a :href="record.url" target="_blank">{{ record.name }}</a>
          </template>

          <template slot="action"> -- </template>
        </a-table>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        systemNo: "",
        certificateNo: "",
        type: "1",
        area: "",
        address: "",
        sameAddress: true,
        realAddress: "1",
        realAddressDetail: "",
        usage: "",

        rightIsAgency: false,
        rightName: "",
        rightCode: "",
        rightIsState: false,
        rightGroup: "",
        rightType: "",

        applicantName: "",
        applicantPhone: "",
        applicantCompany: "",
        applicantCode: "",
        applicantType: "",

        fileList: [],
      },
      boardList: [
        "北外滩板块",
        "大虹桥板块",
        "临港新片区板块",
        "前滩板块",
        "徐汇滨江板块",
        "五大新城板块(嘉定、青浦、松江、奉贤、南汇，包含吴淞创新城板块)",
        "南北转型板块(宝山、金山)",
        "南京西路板块",
        "江宁路板块",
        "陆家嘴滨江板块",
        "张江板块",
        "淮海中路板块",
        "人民广场板块",
        "徐家汇板块",
        "衡山路板块",
        "长寿板块",
        "长风板块",
        "中山公园板块",
        "松江新城板块",
        "崇明新城板块",
      ],

      rules: {
        type: [{ required: true, message: "请选择权证类型" }],
        area: [{ required: true, message: "请输入面积" }],
        address: [{ required: true, message: "请输入权证地址" }],
      },

      fileColumns: [
        { title: "序号", dataIndex: "id", width: 80 },
        { title: "附件类型", dataIndex: "type" },
        {
          title: "附件信息",
          dataIndex: "file",
          scopedSlots: { customRender: "file" },
        },
        {
          title: "操作",
          dataIndex: "action",
          width: 80,
          scopedSlots: { customRender: "action" },
        },
      ],
    };
  },
};
</script>

<style scoped>
.detail-collapse {
  background: #fff;
}
.detail-collapse /deep/ .ant-collapse-header {
  font-size: 15px;
  font-weight: bold;
}
.detail-collapse /deep/ input.ant-input {
  height: 32px !important;
  border-radius: 4px;
}

::v-deep .detail-collapse .ant-form-item {
  margin-bottom: 4px !important;   /* 自己改 */
}

.title_icon {
  width: 6px;
  height: 22px;
  background: #007aff;
}
</style>
